import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { useLazyCheckoutItemQuery } from "../../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { ComponentTypes } from "../../../src/taskpane/config/config";
import { OneNoteProgId, SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";

export function useMenuItem_Checkout(
    selectedItems: any[],
    waitFor: boolean,
    setWaitFor: (waitFor: boolean) => void,
    isInOneDrive: boolean,
    setGridItemIsBusy: (items: any[], isBusy: boolean) => void,
    updateGridItems: (items: any[]) => void,
    setIsCMErrorModalOpen: (isCMErrorModalOpen: boolean) => void,
    setErrorMessage?: (errorMessage: string) => void,
) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
    const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);

    const [menuItem_Checkout, setMenuItem_Checkout] = React.useState<IContextualMenuItem>();

    const [checkoutItem] = useLazyCheckoutItemQuery();

    const menuItem: IContextualMenuItem = {
        key: 'checkout',
        disabled: waitFor === true,
        name: languageStrings.CheckOut,
        iconProps: { iconName: "CheckedOutByOther12" },
        onClick: () => {
            onCheckoutItem();
        }
    }

    React.useEffect(() => {
        if (!isInOneDrive &&
            selectedItems.length > 0 && currentDirectory.type !== ComponentTypes.SharePointList &&
            selectedItems?.every(x => !x?.CheckoutUser) &&
            !(selectedItems?.some(x => x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) || selectedItems?.some(x => x.ProgId === OneNoteProgId)) &&
            !(selectedItems.some(x => x?.EffectiveBasePermissions?.canEditListItem === false))
        ) {
            setMenuItem_Checkout(menuItem)
        }
        else {
            setMenuItem_Checkout(null)
        }
    }, [selectedItems, waitFor, isInOneDrive, currentDirectory, currentSharepointFolder]);

    const onCheckoutItem = async () => {
        setGridItemIsBusy(selectedItems, true);
        setWaitFor(true);
        await Promise.all(selectedItems.map(async item => {
            try {
                await checkoutItem({
                    siteUrl: currentDirectory.webUrl,
                    uniqueId: item.UniqueId.replace("{", "").replace("}", ""),
                    accessToken: isInOneDrive ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
                }).unwrap();
            } catch (error) {
                setIsCMErrorModalOpen(true);
                setErrorMessage(error['data']['odata.error']['message']['value']);
            }
        }));

        updateGridItems(selectedItems);
        setWaitFor(false);
    }

    return {
        menuItem_Checkout
    }

}